/* src/app/shared/components/report-card/report-card.component.scss */
@media only screen and (max-width: 720px) {
  .report-card-group-fixed {
    padding: 0 6px;
  }
  .report-card-desc-fixed {
    padding: 0 6px;
  }
}
.report-card-group-fixed {
  padding: 0 12px;
  display: flex;
  justify-content: center;
}
.report-card-desc-fixed {
  padding: 0 12px;
  display: flex;
  justify-content: center;
}
.report-card-shell {
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  padding-bottom: 56px;
}
.report-card-img-container {
  position: relative;
  padding-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
}
.report-card-img-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-top: 18px;
}
.report-card-img {
  width: 160px;
  height: 240px;
  object-fit: cover;
}
.report-card-type-grid {
  padding: 0;
}
.report-card-type-row-inner {
  align-items: center;
}
.report-type-icon {
  font-size: 0.85rem;
}
.report-card-title {
  text-align: center;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 1.25rem;
  margin-top: 8px;
}
.report-card-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 9px 2px 0px 2px;
  gap: 6px;
}
.report-card-title-text {
  font-size: 0.85rem;
  color: var(--ion-color-primary-contrast);
  margin-bottom: 2px;
}
.report-card-collection {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  border-radius: 12px;
  padding: 8px;
}
.report-card-collection ion-icon {
  font-size: 0.82rem;
}
.report-card-groupname {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.73rem;
}
.report-card-group {
  font-size: 0.73rem;
}
.report-card-desc-link {
  position: absolute;
  bottom: 62px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  color: var(--ion-color-medium);
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.97rem;
}
.report-card-desc-link-mobile {
  white-space: nowrap;
  color: var(--ion-color-medium);
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.97rem;
}
.report-card-desc {
  font-size: 0.97rem;
  color: var(--ion-color-medium);
}
.report-card-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  box-shadow: none;
  background: var(--ion-card-background, var(--ion-color-tertiary));
  display: flex;
  justify-content: center;
  padding: 4px 0;
}
.report-card-fav-btn {
  width: 90%;
  max-width: 220px;
  font-weight: 500;
}
@media only screen and (min-width: 720px) {
  ion-card {
    width: 250px;
    height: 345px;
  }
  ion-card hr {
    border-bottom: 1px solid var(--ion-color-secondary-contrast);
  }
  ion-card .icon {
    display: block;
    margin-left: auto;
    margin-right: auto;
    zoom: 1.3;
  }
  ion-card .favorite-icon {
    border-radius: 35%;
    padding: 1px;
  }
  ion-card .favorite-icon:hover {
    transform: scale(1.2);
    background-color: rgba(255, 255, 255, 0.062745098);
  }
  ion-card .favorite-icon {
    zoom: 1.6;
  }
  ion-card .group-logo {
    height: 150px;
    width: 190px;
    object-fit: contain;
    margin-left: auto;
    margin-right: auto;
  }
  ion-card .report-card-img-container {
    min-height: 150px;
  }
  ion-card .card-title {
    font-size: 17px;
    margin-top: -7px;
    padding-top: 0px;
    padding-right: 9px;
    padding-bottom: 5px;
    padding-left: 9px;
  }
  ion-card .card-content {
    bottom: 10px;
    font-size: 14px;
    font-weight: initial;
  }
  ion-card .item.native .item-inner {
    padding-right: 0px !important;
    --inner-padding-end: 0px !important;
  }
}
.hoverOnCard:hover {
  cursor: pointer;
}
.description-popover {
  --width: 320px !important;
  --max-width: 90vw !important;
  --border-radius: 12px !important;
}
.description-popover .description-popover-content {
  --background: var(--ion-color-secondary) !important;
  color: var(--ion-color-secondary-contrast) !important;
}
.description-popover .description-popover-content .description-header {
  display: flex;
  align-items: center;
  padding: 16px 20px 12px 20px;
  background: var(--ion-color-medium);
}
.description-popover .description-popover-content .description-header .description-icon {
  font-size: 20px;
  margin-right: 10px;
}
.description-popover .description-popover-content .description-header .description-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ion-color-primary-contrast);
}
.description-popover .description-popover-content .description-body {
  padding: 16px 20px;
}
.description-popover .description-popover-content .description-body .description-text {
  line-height: 1.5;
}
.custom-popover-css {
  --width: fit-content !important;
}
@media only screen and (max-width: 720px) {
  ion-card {
    zoom: 0.9;
    width: 196px;
    height: 285px;
  }
  ion-card hr {
    border-bottom: 1px solid var(--ion-color-secondary-contrast);
  }
  ion-card .icon {
    display: block;
    margin-left: auto;
    margin-right: auto;
    color: var(--ion-color-secondary-contrast);
  }
  ion-card .group-logo {
    height: 100px;
    width: 210px;
    object-fit: contain;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  ion-card .report-card-img-container {
    min-height: 85px;
  }
  ion-card .card-title {
    color: var(--ion-color-primary-contrast);
    font-size: 14px;
  }
  ion-card .card-content {
    font-size: 12px;
    font-weight: initial;
  }
  ion-card .card-detailsbutton {
    background-color: rgba(255, 255, 255, 0.0509803922);
    padding-left: 10px;
    padding-top: 3px;
    padding-right: 10px;
    padding-bottom: 3px;
    border-radius: 6px;
  }
}
/*# sourceMappingURL=report-card.component-26YI7TRF.css.map */
